<div class="container">
  <div class="container-content d-flex justify-column">
    <div class="content-card card d-flex align-center mt-4 mb-4 vw-100">
      <div class="card-info info d-flex align-center">
        <ng-container>
          <div class="info-data data d-flex align-center">
            <div
              class="data-labels labels flex-{{ card.flexSize }}"
              [ngClass]="{
                'text-center':
                  cardType === DialogEmailTypeEnum.StoreConfig ||
                  cardType === DialogEmailTypeEnum.ReverseConfig
              }"
              *ngFor="let card of cardData"
            >
              <span *ngIf="!card.isSelect"> {{ card.value }} </span>

              <ng-container *ngIf="card.isSelect">
                <div class="vw-100 d-flex justify-center">
                  <app-c-select
                    class="email-select"
                    width="200px"
                    height="34px"
                    placeholder="Selecione"
                    [formControl]="emailTrigger"
                    [data]="emailOpts"
                    (change)="changeEmailSelect()"
                  ></app-c-select>
                </div>
              </ng-container>
            </div>
            <div
              class="card-buttons flex-2 d-flex justify-flex-end"
              [ngClass]="{
                'flex-1':
                  cardType === DialogEmailTypeEnum.StoreConfig ||
                  cardType === DialogEmailTypeEnum.ReverseConfig,
                'flex-2':
                  cardType !== DialogEmailTypeEnum.StoreConfig &&
                  cardType !== DialogEmailTypeEnum.ReverseConfig
              }"
            >
              <ng-container>
                <button
                  class="btn mr-5"
                  (click)="
                    cardType === DialogEmailTypeEnum.Parameters
                      ? openParameterDialog()
                      : cardType === DialogEmailTypeEnum.StoreConfig ||
                        cardType === DialogEmailTypeEnum.ReverseConfig
                      ? handleDialogConfig('edit')
                      : openEmailDialog()
                  "
                >
                  <app-svg-icon
                    width="15px"
                    height="17px"
                    src="assets/icons/edit-icon.svg"
                    color="white"
                  >
                  </app-svg-icon>
                </button>

                <button
                  *ngIf="
                    cardType === DialogEmailTypeEnum.Transfer ||
                    cardType === DialogEmailTypeEnum.StoreConfig ||
                    cardType === DialogEmailTypeEnum.ReverseConfig
                  "
                  class="btn"
                  (click)="
                    cardType === DialogEmailTypeEnum.StoreConfig ||
                    cardType === DialogEmailTypeEnum.ReverseConfig
                      ? handleDialogConfig('delete')
                      : handleDeleteParameter()
                  "
                >
                  <app-svg-icon
                    class="ml-1"
                    width="15px"
                    height="17px"
                    src="assets/icons/trash-icon.svg"
                    color="white"
                  >
                  </app-svg-icon>
                </button>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
